import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { ReadShift, WriteShift } from "@/types/shift";

export const useShiftDictionary = () => {
  const config = getDictionaryConfig<ReadShift, WriteShift>(Module.Shifts);
  return config;
};
